/// Jauge livraison offerte (snippets/free-shipping-bar.liquid) ///
(function () {
  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}} €';
    cents = parseInt(cents, 10) || 0;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      var parts = (number / 100.0).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = fmt.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function update(total, root) {
    total = parseInt(total, 10);
    if (isNaN(total)) return;
    var scope = root || document;
    scope.querySelectorAll('[data-fsb]').forEach(function (el) {
      var tiers = (el.dataset.fsbTiers || '').split(';;').filter(Boolean).map(function (t) {
        var p = t.split('|');
        return { amount: parseInt(p[0], 10) || 0, label: p[1] || '', unlocked: p[2] || '' };
      });
      if (!tiers.length) return;

      var fmt = el.dataset.fsbMoneyFormat || '{{amount}} €';
      var max = tiers[tiers.length - 1].amount || 1;
      var next = null;
      var unlockedLabel = '';
      tiers.forEach(function (t) {
        if (total >= t.amount) unlockedLabel = t.unlocked;
        else if (!next) next = t;
      });

      var percent = Math.max(0, Math.min(100, (total / max) * 100));
      var msg;
      if (!next) {
        msg = (el.dataset.fsbMsgUnlocked || '').replace('[palier]', unlockedLabel);
      } else if (total === 0) {
        msg = (el.dataset.fsbMsgEmpty || '').replace('[montant]', formatMoney(next.amount, fmt)).replace('[palier]', next.label);
      } else {
        msg = (el.dataset.fsbMsgProgress || '').replace('[montant]', formatMoney(next.amount - total, fmt)).replace('[palier]', next.label);
      }

      var textEl = el.querySelector('.fsb__text');
      if (textEl) textEl.textContent = msg;
      var fill = el.querySelector('.fsb__fill');
      if (fill) fill.style.width = percent + '%';
      var track = el.querySelector('.fsb__track');
      if (track) track.setAttribute('aria-valuenow', Math.round(percent));
      el.classList.toggle('fsb--unlocked', !next);
      el.querySelectorAll('[data-fsb-amount]').forEach(function (m) {
        m.classList.toggle('is-reached', total >= (parseInt(m.dataset.fsbAmount, 10) || 0));
      });
      el.dataset.fsbTotal = total;
    });
  }

  // Resynchronise toutes les jauges depuis le rendu serveur (utile quand certains
  // produits sont exclus du seuil via un tag : seul Liquid connaît les tags).
  function sync() {
    return fetch('/cart?view=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fsb]');
        if (fresh && typeof fresh.dataset.fsbTotal !== 'undefined') update(fresh.dataset.fsbTotal);
        document.querySelectorAll('.fsb__note').forEach(function (n) {
          var freshNote = fresh && fresh.querySelector('.fsb__note');
          if (freshNote) n.textContent = freshNote.textContent;
        });
      })
      .catch(function () {});
  }

  window.MaisonFSB = { update: update, sync: sync, formatMoney: formatMoney };

  // Tout script du thème (ou d'une app) peut déclencher :
  // document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartJson }))
  document.addEventListener('cart:updated', function (e) {
    var allMode = !document.querySelector('[data-fsb][data-fsb-mode="tag"]');
    if (allMode && e.detail && typeof e.detail.total_price !== 'undefined') update(e.detail.total_price);
    sync();
  });
})();
